class AutoChecker extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.input = this.querySelector("input.input, textarea.textarea");
    this.checkbox = this.querySelector("input#handwritten-card");
    this.quantityInput = document.querySelector("buy-buttons .quantity-selector__input");
    this.increaseBtn = document.querySelector("buy-buttons .quantity-selector__button.increase");

    if (!this.input || !this.checkbox || !this.quantityInput || !this.increaseBtn) return;

    this.input.addEventListener(
      "input",
      this.#handleInputChange.bind(this),
      { signal: this.#controller.signal }
    );
  }

  #handleInputChange() {
    const currentValue = this.input.value;
    const maxLength = 250;
    if (currentValue.length > maxLength) {
      this.input.value = currentValue.substring(0, maxLength);
    }
    
    const hasText = this.input.value.trim().length > 0;
    this.checkbox.checked = hasText;
    this.#toggleQuantityLock(hasText);
  }

  #toggleQuantityLock(isChecked) {
    if (!this.quantityInput || !this.increaseBtn) return;

    if (isChecked) {
      this.quantityInput.value = 1;
      this.increaseBtn.disabled = true;
      this.quantityInput.setAttribute("max", "1");
    } else {
      this.increaseBtn.disabled = false;
      this.quantityInput.removeAttribute("max");
    }
  }

  disconnectedCallback() {
    this.#controller.abort();
  }
}

if (!customElements.get("auto-checker")) {
  customElements.define("auto-checker", AutoChecker);
}